import { Component, EventEmitter, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchBarAddressesMapsService, PlaceResult } from './service/search-bar-addresses.service';
import { Subscription } from 'rxjs';

// Declaración para el objeto global de Google Maps
declare global {
  interface Window {
    google: any;
  }
}

@Component({
  selector: 'modal-view-search-bar-addresses',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-bar-addresses.component.html',
  styleUrl: './search-bar-addresses.component.css'
})
export class SearchBarAddressesComponent implements OnInit {
  searchText: string = '';
  isActive: boolean = false;
  searchResults: PlaceResult[] = [];
  isLoading: boolean = false;
  showResults: boolean = false;
  private searchSubscription?: Subscription;

  constructor(private searchService: SearchBarAddressesMapsService, private cdr: ChangeDetectorRef) {}

  // Método para manejar el enfoque del input
  toggleActive(event: Event): void {
    this.isActive = true;
  }

  // Método para manejar la pérdida de enfoque
  onBlur(): void {
    if (!this.searchText) {
      this.isActive = false;
    }
  }

  ngOnInit(): void {
    // Inicializar el servicio y configurar la suscripción para búsquedas automáticas
    this.searchSubscription = this.searchService.mapsService.scriptLoaded$.subscribe(loaded => {
      if (loaded) {
        // console.log('Google Maps API cargada correctamente en el componente de búsqueda');
      }
      this.cdr.detectChanges();
    });
  }

  // Método para realizar la búsqueda
  search(): void {
    if (this.searchText.trim()) {
      // console.log('Buscando dirección:', this.searchText);
      this.isLoading = true;
      this.cdr.detectChanges();
      this.searchService.searchAddresses(this.searchText).subscribe({
        next: (results) => {
          this.searchResults = results;
          this.showResults = results.length > 0;
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error al buscar direcciones:', error);
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
    } else {
      this.clearResults();
    }
  }

  // Evento para emitir la ubicación seleccionada
  @Output() locationSelected = new EventEmitter<{
    location: { lat: number, lng: number },
    address: string
  }>();

  // Método para seleccionar una dirección
  selectAddress(place: PlaceResult): void {
    this.searchText = place.description;
    this.clearResults();
    this.cdr.detectChanges();

    // Obtener detalles del lugar seleccionado
    this.searchService.getPlaceDetails(place.place_id).subscribe({
      next: (details) => {
        if (details && details.geometry && details.geometry.location) {
          const location = {
            lat: details.geometry.location.lat(),
            lng: details.geometry.location.lng()
          };

          // Emitir evento con la ubicación seleccionada
          this.locationSelected.emit({
            location: location,
            address: place.description
          });

          // console.log('Ubicación seleccionada:', location);
          this.cdr.detectChanges();
        }
      },
      error: (error) => {
        console.error('Error al obtener detalles del lugar:', error);
        this.cdr.detectChanges();
      }
    });
  }

  // Método para limpiar los resultados
  clearResults(): void {
    this.searchResults = [];
    this.showResults = false;
    this.cdr.detectChanges();
  }
}
